import Component from '@bythepixel/component-loader';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

const DEFAULTS = {
  activatorSelector: '[data-comp-slider]',
  sliderSettingsSelector: '[data-comp-slider-settings]',
  splideSettings: {
    type: 'loop',
    mediaQuery: 'min',
    perPage: 3,
    arrows: false,
  },
};

export default class ImageSlider extends Component {
  static selector = '[data-comp-slider]';

  splide = null;

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.setSliderOptions();
    this.mount();
  }

  initSplide() {
    const { splideSettings } = this;
    this.splide = new Splide(this.$container, splideSettings);
    return this;
  }

  setSliderOptions() {
    this.splideSettings = this.$options.splideSettings;

    const inlineOptions = this.$container.dataset.compSliderSettings;

    if (!inlineOptions) return;

    try {
      const parsedOptions = JSON.parse(inlineOptions);

      this.splideSettings = {
        ...this.splideSettings,
        ...parsedOptions,
      };
    } catch (err) {
      console.error(`Invalid JSON string passed into ${this.$options.optionsSelector}. Using default options.`);
      console.error(err);
    }
  }

  useAutoscroll() {
    return this.$container.dataset.compSliderAutoscroll === 'true';
  }

  mount() {
    let extensions = {};

    if (this.useAutoscroll()) {
      extensions = {
        ...extensions,
        AutoScroll,
      };
    }

    this.initSplide()
      .splide
      .mount(extensions);
  }
}
